import { fetchUserNotifications, updateUserNotifications } from '/b2b/notifications/services';

import AuthUserActions from '/b2b/authentication/state/user/AuthUser.actions';
import { formatSettingsWithPreferences } from '/b2b/notifications/format';
import schema from '/b2b/users/state/db/User.schema';

export const fetchUserNotificationSettings = params => dispatch => {
    const { userId } = params;
    const meta = { schema, id: userId };
    dispatch(AuthUserActions.fetchDetailsBegin(meta, params));

    return fetchUserNotifications()
        .then(settings => {
            const notificationSettings = formatSettingsWithPreferences(settings);
            dispatch(
                AuthUserActions.fetchDetailsSuccess(meta, params, {
                    id: userId,
                    notificationSettings,
                })
            );
            return notificationSettings;
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthUserActions.fetchDetailsFailure(meta, params, message));
            throw message;
        });
};

export const updateUserNotificationSettings = params => dispatch => {
    const { userId, settings } = params;

    const meta = { schema, id: userId };
    dispatch(AuthUserActions.updateBegin(meta, params));

    return updateUserNotifications(settings)
        .then(updatedSettings => {
            const notificationSettings = formatSettingsWithPreferences(updatedSettings);
            dispatch(
                AuthUserActions.updateSuccess(meta, params, {
                    id: userId,
                    notificationSettings,
                })
            );
            return notificationSettings;
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthUserActions.updateFailure(meta, params, message));
            throw message;
        });
};
